import React, { useEffect, useState, useRef, useMemo } from "react";
import { categoryOptions } from "../../../services/category.services";
import { subCategoryOptions, subCategoryDetail } from "../../../services/subCategory.services";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { menuItemList, deleteMenuItem, addMenuItem, editMenuItem, menuItemDetails, sortMenuItems, latest_menu_item_code, UpsellMenuOptions } from "../../../services/menuItem.services";
import { useValidationSchemas } from "../../../validator/validation";
import { useTranslation } from "react-i18next";
import { ITEM_TAX_OPTIONS, ITEM_TYPES, ITEM_VARIATION, LOADER_TIMEOUT_TIME, SOCKET_CLIENT_EVENTS, SOCKET_EVENTS, SWAL_SETTINGS } from "../../../../../utils/Constants";
import Swal from "sweetalert2";
import { booleanMask, calculateTaxPrice, getTranslatedKey, globalLoader, handleOffcanvasScroll, handleServerValidations, showPrice, useDebouncing } from "../../../../../utils/commonfunction";
import trash from "../../../../../assets/restaurant/images/trash.svg";
import { useFormik } from "formik";
import CustomError from "../../../../../utils/customError";
import { ReactSortable } from "react-sortablejs";
import { Options } from "../../../services/addons.service";
import { addonGroupSlots, usedAddonLimits } from "../utils/addonLimits";
import { Drawer, SelectPicker, Whisper, Tooltip, Modal } from "rsuite";
import GridLoader from "../../../shared/gridLoader";
import RecordNotFound from "../../../shared/recordNotFound";
import { useSelector } from "react-redux";
import { SOCKET_CLIENT } from "../../../../../utils/socket";
import CustomPagination from "../../../../admin/common/custompagination";
import { buildMenuItemListFormData } from "../utils/menuItemListRequest";
import { buildClonedMenuItemValues } from "../utils/buildClonedMenuItemValues";
import CategoryCardActions from "../shared/CategoryCardActions";
import AddonGroupRows from "../shared/AddonGroupRows";

export default function MenuItemListing() {
  const params = useParams();
  const location = useLocation();
  const [categoryList, setCategoryList] = useState([]);
  const [categoryFilterOptions, setCategoryFilterOptions] = useState([]);
  const [addSubCategoryList, setAddSubCategoryList] = useState([]);
  const [editSubCategoryList, setEditSubCategoryList] = useState([]);
  const [filterSubCategoryList, setFilterSubCategoryList] = useState([]);
  const [filterCategoryId, setFilterCategoryId] = useState(() => params.id || "");
  const [filterSubCategoryId, setFilterSubCategoryId] = useState(() => {
    return new URLSearchParams(location.search).get("sub_category_id") || "";
  });

  const [sortableCategories, setSortableCategories] = useState([]);
  const [search, setSearch] = useState({});
  const [refreshList, setRefreshList] = useState(false);
  const [List, setList] = useState([]);
  const sortingCloseBtn = useRef();
  const [loader, setLoader] = useState(true);
  const [page, setPage] = useState(1);
  const [offset, setOffsetPage] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const [itemPerPage] = useState(10);
  const { t } = useTranslation();
  const { menuItemsValidationSchema } = useValidationSchemas();
  const navigate = useNavigate();

  // ponytail: tax-type selector hidden for now (all items save as inclusive).
  // Flip to true to bring back the inclusive/exclusive dropdown in add/edit forms.
  const SHOW_TAX_TYPE_OPTION = false;

  const [ItemDetail, setItemDetail] = useState({});
  const [ItemOption, setItemOption] = useState([]);
  const [OptionsData, setOptionsData] = useState([]);
  const [openWithHeader, setOpenWithHeader] = useState(false);
  const [openWithHeaderEdit, setOpenWithHeaderEdit] = useState(false);
  const [globalSearch, setGlobalSearch] = useState("");
  const [langChanged, setLangChanged] = useState(false);
  const restSettingDetails = useSelector((state) => state?.restSettings?.data);
  const [addSubmissionLoader, setAddSubmissionLoader] = useState(false);
  const [editSubmissionLoader, setEditSubmissionLoader] = useState(false);
  const [selectedMenuItem, setSelectedMenuItem] = useState(null);
  const [itemUpsellOptions, setItemUpsellOptions] = useState([]);
  const [itemUpsellOptionsData, setItemUpsellOptionsData] = useState([]);
  const [openUpsellModal, setOpenUpsellModal] = useState(false);
  const [selectedUpsellIds, setSelectedUpsellIds] = useState([]);

  const addItemForm = useFormik({
    initialValues: {
      item_name: "",
      item_name_ja: "",
      category_id: "",
      sub_category_id: "",
      item_code: "",
      short_description: "",
      short_description_ja: "",
      selected_addon: "",
      addons: [],
      addon_limits: {},
      price: 0,
      cost_price: 0,
      consumption_tax_rate: 0,
      item_tax_type: ITEM_TAX_OPTIONS.INCLUSIVE,
      spice_level_needed: false,
      is_upsell: false,
      image: "",
      type: "",
      item_variation: "",
      upsell_items: [],
    },
    validationSchema: menuItemsValidationSchema,
    // Inert by design: every initialValues key above is a static literal — keep it
    // that way. A reactive value here re-triggers the form-reset race fixed in this
    // file (item_code arrives via setFieldValue, never via initialValues).
    enableReinitialize: true,
    onSubmit: (values, { resetForm, setFieldValue }) => {
      setAddSubmissionLoader(true);
      const formData = new FormData();
      const sanitizedUpsellItems = sanitizeUpsellSelection(values.upsell_items || []);
      formData.append("item_name", values.item_name);
      formData.append("item_name_ja", values.item_name_ja);
      formData.append("category_id", values.category_id);
      formData.append("sub_category_id", values.sub_category_id || "");
      formData.append("item_code", values.item_code);
      formData.append("short_description", values.short_description);
      formData.append("short_description_ja", values.short_description_ja);
      formData.append("price", findTax()?.price_without_tax);
      formData.append("total_price", findTax()?.price_with_tax);
      formData.append("tax_price", findTax()?.tax_price);
      formData.append("cost_price", values.cost_price);
      formData.append("consumption_tax_rate", findTax()?.tax_rate);
      formData.append("type", values.type);
      formData.append("spice_level_needed", ITEM_TYPES.SET_OF_ITEMS !== values.type ? values.spice_level_needed : null);
      formData.append("is_upsell", values.is_upsell);
      formData.append("image", values.image);
      formData.append("item_tax_type", values.item_tax_type);
      formData.append("addons", JSON.stringify(values.addons));
      // Pruned: a ceiling for a group this set dropped must not outlive it.
      formData.append("addon_limits", JSON.stringify(usedAddonLimits(values)));
      formData.append("original_amount", values.price);
      formData.append("item_variation", values.item_variation);
      formData.append("upsell_items", JSON.stringify(sanitizedUpsellItems));

      addMenuItem(formData)
        .then((response) => {
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            setFieldValue("image", "");
            resetForm();
            document.getElementById("image").value = "";
            setOpenWithHeader(false);
            setRefreshList(!refreshList);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
          setAddSubmissionLoader(false);
        })
        .catch((error) => {
          console.error("Error updating profile", error);
          setAddSubmissionLoader(false);
        });
      // console.log(values);
    },
  });

  const editItemForm = useFormik({
    initialValues: {
      o_id: "",
      item_name: "",
      item_name_ja: "",
      category_id: "",
      sub_category_id: "",
      item_code: "",
      short_description: "",
      short_description_ja: "",
      selected_addon: "",
      addons: [],
      addon_limits: {},
      price: 0,
      cost_price: 0,
      consumption_tax_rate: 0,
      item_tax_type: "",
      spice_level_needed: "",
      is_upsell: false,
      image: "",
      type: "",
      item_variation: "",
      upsell_items: [],
    },
    validationSchema: menuItemsValidationSchema,
    onSubmit: (values, { resetForm, setFieldValue }) => {
      setEditSubmissionLoader(true);
      const formData = new FormData();
      const sanitizedUpsellItems = sanitizeUpsellSelection(values.upsell_items || [], values?.o_id);
      formData.append("o_id", values.o_id);
      formData.append("item_name", values.item_name);
      formData.append("item_name_ja", values.item_name_ja);
      formData.append("category_id", values.category_id);
      formData.append("sub_category_id", values.sub_category_id || "");
      formData.append("item_code", values.item_code);
      formData.append("short_description", values.short_description);
      formData.append("short_description_ja", values.short_description_ja);
      formData.append("price", findTax(editItemForm, values.category_id)?.price_without_tax);
      formData.append("total_price", findTax(editItemForm, values.category_id)?.price_with_tax);
      formData.append("tax_price", findTax(editItemForm, values.category_id)?.tax_price);
      formData.append("cost_price", values.cost_price);
      formData.append("consumption_tax_rate", findTax(editItemForm, values.category_id)?.tax_rate);
      formData.append("type", values.type);
      formData.append("spice_level_needed", ITEM_TYPES.SET_OF_ITEMS !== values.type ? values.spice_level_needed : null);
      formData.append("is_upsell", values.is_upsell);
      formData.append("image", values.image);
      formData.append("item_tax_type", values.item_tax_type);
      formData.append("addons", JSON.stringify(values.addons));
      // Pruned: a ceiling for a group this set dropped must not outlive it.
      formData.append("addon_limits", JSON.stringify(usedAddonLimits(values)));
      formData.append("original_amount", values.price);
      formData.append("item_variation", values.item_variation);
      formData.append("upsell_items", JSON.stringify(sanitizedUpsellItems));

      editMenuItem(formData)
        .then((response) => {
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            setFieldValue("image", "");
            resetForm();
            document.getElementById("image").value = "";
            setOpenWithHeaderEdit(false);
            setRefreshList(!refreshList);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
          }
          setEditSubmissionLoader(false);
        })
        .catch((error) => {
          console.error("Error updating profile", error);
          setEditSubmissionLoader(false);
        });
      // console.log(values);
    },
  });

  const currentEditItemId = editItemForm?.values?.o_id || selectedMenuItem?._id || null;
  const upsellOptionsForModal = openWithHeaderEdit
    ? itemUpsellOptions.filter((item) => item?._id !== currentEditItemId)
    : itemUpsellOptions;
  const availableUpsellIds = useMemo(() => new Set(itemUpsellOptions.map((item) => item?._id)), [itemUpsellOptions]);

  const sanitizeUpsellSelection = (ids = [], excludeItemId = null) => {
    if (!Array.isArray(ids)) return [];
    const uniqueIds = [...new Set(ids)].filter((id) => availableUpsellIds.has(id));
    if (!excludeItemId) return uniqueIds;
    return uniqueIds.filter((id) => id !== excludeItemId);
  };

  const addFormValidUpsellCount = sanitizeUpsellSelection(addItemForm?.values?.upsell_items || []).length;
  const editFormValidUpsellCount = sanitizeUpsellSelection(editItemForm?.values?.upsell_items || [], currentEditItemId).length;

  useEffect(() => {
    const addUpsell = addItemForm?.values?.upsell_items || [];
    const sanitizedAddUpsell = sanitizeUpsellSelection(addUpsell);
    if (JSON.stringify(addUpsell) !== JSON.stringify(sanitizedAddUpsell)) {
      addItemForm.setFieldValue("upsell_items", sanitizedAddUpsell);
    }

    const editUpsell = editItemForm?.values?.upsell_items || [];
    const sanitizedEditUpsell = sanitizeUpsellSelection(editUpsell, currentEditItemId);
    if (JSON.stringify(editUpsell) !== JSON.stringify(sanitizedEditUpsell)) {
      editItemForm.setFieldValue("upsell_items", sanitizedEditUpsell);
    }
  }, [itemUpsellOptions, currentEditItemId]);

  const findTax = (form = addItemForm, categoryId = null) => {
    const category = categoryList.find((obj) => obj?._id === (categoryId ? categoryId : form.values.category_id));
    let result = {
      tax_price: 0,
      price_without_tax: 0,
      price_with_tax: 0,
      tax_rate: 0,
    };
    if (category) {
      result.tax_rate = category.tax_type === "dine" ? 10 : 8;
      const price = Number(form.values.price);
      if (price) {
        // Tax-exclusive is removed: the entered price is always the tax-INCLUSIVE
        // gross, so tax is extracted from it and the total equals the input.
        const tax_price = calculateTaxPrice(price, result.tax_rate, ITEM_TAX_OPTIONS.INCLUSIVE, restSettingDetails?.tax_when_register_product);
        result.tax_price = tax_price;
        result.price_without_tax = price - tax_price;
        result.price_with_tax = price;
      }
    }
    //  console.log(result)
    return result;
  };

  const fetchSubCategories = (categoryId, setter) => {
    if (categoryId) {
      return subCategoryOptions(categoryId).then((res) => {
        setter(res?.data || []);
        return res?.data || [];
      }).catch(() => { setter([]); return []; });
    } else {
      setter([]);
      return Promise.resolve([]);
    }
  };

  useEffect(() => {
    const subCategoryId = new URLSearchParams(location.search).get("sub_category_id");
    if (subCategoryId) {
      subCategoryDetail({ o_id: subCategoryId }).then((res) => {
        if (res.success) {
          const catId = res.data?.category_id;
          setFilterCategoryId(catId);
          fetchSubCategories(catId, setFilterSubCategoryList);
        }
      }).catch(() => { });
    } else if (params.id) {
      fetchSubCategories(params.id, setFilterSubCategoryList);
    }
  }, []);

  useEffect(() => {
    categoryOptions(true)
      .then((response) => {
        setCategoryList(response?.data ? response.data.filter((record) => !record?.is_unCategorized) : []);
        setCategoryFilterOptions(response?.data ? response.data : []);
      })
      .catch((err) => {
        console.log(err);
      });

    Options()
      .then((response) => {
        const formattedOptions = response.data.map((item, i) => ({
          label: item.addon_name,
          value: item._id,
        }));
        setItemOption(response.data);
        setOptionsData(formattedOptions);
      })
      .catch((err) => {
        console.log(err);
      });

    UpsellMenuOptions()
      .then((response) => {
        const formattedUpsellOptions = response.data.map((item, i) => ({
          label: item.name,
          value: item._id,
        }));
        setItemUpsellOptions(response.data);
        setItemUpsellOptionsData(formattedUpsellOptions);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [langChanged]);

  // useEffect(()=>{
  //   setOptionsData((options)=>{
  //     return options.map((op, i)=>{
  //       return i===0? op: {disabled:true,...op}
  //     })
  //   });
  // },[addItemForm.values]);

  // const prepareSearch = (key, value) => {
  //   let sr = { ...search };
  //   if (String(value).length > 0) {
  //     sr[key] = value;
  //   } else {
  //     delete sr[key];
  //   }
  //   setSearch(sr);
  // };
  const prepareGlobalSearch = (value) => {
    setPage(1);
    setGlobalSearch(value);
  };
  const searchDebounce = useDebouncing(prepareGlobalSearch);

  const getMenuItemListRequestData = (includePagination = true) =>
    buildMenuItemListFormData({
      page,
      itemPerPage,
      search,
      globalSearch,
      filterCategoryId,
      filterSubCategoryId,
      includePagination,
    });

  const getSortableMenuItemList = () => {
    menuItemList(getMenuItemListRequestData(false))
      .then((data) => {
        setSortableCategories(data && data.data && data.data.list ? data.data.list : []);
      })
      .catch(() => {
        setSortableCategories([]);
        Swal.fire({
          icon: "error",
          text: t("sort_menu_item_load_error"),
          ...SWAL_SETTINGS,
        });
      });
  };

  const getMenuItemList = () => {
    setLoader(true);
    menuItemList(getMenuItemListRequestData())
      .then((data) => {
        setList(data && data.data && data.data.list ? data.data.list : []);
        setPage(data?.data?.page || 1);
        setOffsetPage(data?.data?.offset || 0);
        setTotalRecords(data?.data?.total_records || 0);
        setTimeout(() => {
          setLoader(false);
        }, LOADER_TIMEOUT_TIME);
      })
      .catch(() => {
        setList([]);
        setOffsetPage(0);
        setTotalRecords(0);
        setTimeout(() => {
          setLoader(false);
        }, LOADER_TIMEOUT_TIME);
      });
  }
  useEffect(() => {
    getMenuItemList();
  }, [search, refreshList, globalSearch, langChanged, filterCategoryId, filterSubCategoryId, page]);

  const deleteItem = (item) => {
    Swal.fire({
      title: t("msg_are_you_sure"),
      text: t("btn_delete_text"),
      imageUrl: trash,
      showCancelButton: true,
      confirmButtonColor: "#dc3545",
      cancelButtonColor: "#6c757d",
      confirmButtonText: t("btn_delete"),
      cancelButtonText: t("btn_cancel"),
      reverseButtons: true,
      customClass: {
        popup: "swal-restaurant",
        confirmButton: "btn btn-danger col",
        cancelButton: "btn btn-secondary col",
      },
      allowOutsideClick: false,
    }).then((result) => {
      if (result.isConfirmed) {
        globalLoader(true);
        deleteMenuItem({ o_id: item._id })
          .then((response) => {
            globalLoader(false);
            if (response.success) {
              Swal.fire({
                icon: "success",
                text: response.message,
                ...SWAL_SETTINGS,
              });
              setRefreshList(!refreshList);
            } else {
              Swal.fire({
                icon: "error",
                text: handleServerValidations(response),
                ...SWAL_SETTINGS,
              });
            }
          })
          .catch((error) => {
            globalLoader(false);
            console.log("deleteError");
          });
      } else {
        setSortableCategories(List);
      }
    });
  };

  const get_menu_item_code = () => {
    latest_menu_item_code()
      .then((response) => {
        // Set only the code field; updating initialValues with enableReinitialize
        // resets the whole form and wipes anything the user already typed.
        addItemForm.setFieldValue("item_code", response.data.item_code);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getItemDetail = (item, openEdit = false) => {
    menuItemDetails({ o_id: item._id })
      .then((response) => {
        if (response.success) {
          let activeAddons = response?.data?.addons.filter((addon) => getAddon(addon.option_id)?._id).map((addon) => {
            let assignedItems = getAddon(addon.option_id)?.assigned_items || [];
            let itemExists = assignedItems.filter(addonItem => addonItem?._id === addon.item_id)[0];
            return {
              item_id: itemExists ? addon.item_id : "",
              option_id: addon.option_id
            }
          });
          editItemForm.resetForm({ values: {
            o_id: response?.data?._id || "",
            item_name: response?.data?.item_name || "",
            item_name_ja: response?.data?.item_name_ja || "",
            category_id: response?.data?.category_id || "",
            sub_category_id: response?.data?.sub_category_id || "",
            item_code: response?.data?.item_code || "",
            short_description: response?.data?.short_description || "",
            short_description_ja: response?.data?.short_description_ja || "",
            addons: activeAddons || [],
            addon_limits: response?.data?.addon_limits || {},
            price: response?.data?.total_price && response?.data?.item_tax_type === ITEM_TAX_OPTIONS.INCLUSIVE ? response?.data?.total_price : response?.data?.price,
            cost_price: response?.data?.cost_price || 0,
            consumption_tax_rate: response?.data?.consumption_tax_rate || 0,
            item_tax_type: response?.data?.item_tax_type || ITEM_TAX_OPTIONS.INCLUSIVE,
            spice_level_needed: response?.data?.spice_level_needed || false,
            is_upsell: response?.data?.is_upsell || false,
            upsell_items: response?.data?.upsell_items || [],
            image: response?.data?.image || "",
            type: response?.data?.type || "",
            item_variation: response?.data?.item_variation || ""
          } });
          fetchSubCategories(response?.data?.category_id, setEditSubCategoryList).then(() => {
            setItemDetail(response?.data);
            if (openEdit) setOpenWithHeaderEdit(true);
          });
        }
      })
      .catch((err) => {
        console.error(err);
      });
  };
  // Clone: opens the ADD drawer prefilled from an existing item. The value
  // mapping (name suffix, blanked item_code/image, addon pruning) lives in
  // buildClonedMenuItemValues so it can be unit tested.
  const cloneItem = (item) => {
    menuItemDetails({ o_id: item._id })
      .then((response) => {
        if (!response.success) return;
        const detail = response?.data || {};
        addItemForm.setValues(
          buildClonedMenuItemValues(detail, {
            getAddon,
            sanitizeUpsellSelection,
          })
        );
        fetchSubCategories(detail?.category_id, setAddSubCategoryList).then(() => {
          setOpenWithHeader(true);
          get_menu_item_code();
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  function handleSortCategories(closeModal = true) {
    sortMenuItems({ sorted_array: sortableCategories })
      .then((response) => {
        if (response.success) {
          Swal.fire({
            icon: "success",
            text: response.message,
            ...SWAL_SETTINGS,
          });
          if (closeModal) {
            sortingCloseBtn?.current?.click();
          }
          setRefreshList(!refreshList);
        } else {
          Swal.fire({
            icon: "error",
            text: handleServerValidations(response),
            ...SWAL_SETTINGS,
          });
        }
      })
      .catch((error) => {
        console.error("Error updating profile", error);
      });
  }
  function isSortingChanged() {
    let changed = false;
    let i = 0;
    for (i; i < List.length; i++) {
      if (List[i]?.order !== sortableCategories[i]?.order) {
        changed = true;
        break;
      } else {
        changed = false;
      }
    };
    return changed;
  }
  const handleCloseSorting = () => {
    if (isSortingChanged()) {
      Swal.fire({
        title: t("question_to_save_data"),
        text: t("confirm_heading_found_unsaved_data_description"),
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#6c757d",
        cancelButtonColor: "#dc3545",
        confirmButtonText: t("btn_text_save_changes"),
        cancelButtonText: t("btn_text_discard"),
        customClass: {
          popup: "swal-restaurant",
          confirmButton: "btn btn-secondary col",
          cancelButton: "btn btn-danger col",
        },
        allowOutsideClick: false,
      }).then((result) => {
        if (result.isConfirmed) {
          handleSortCategories(false);
        } else {
          setSortableCategories(List);
        }
      });
    }
  };

  const addAddon = (form) => {
    let addons = [...form?.values?.addons];
    if (form?.values?.selected_addon?.length > 0) {
      addons.push({ option_id: form?.values?.selected_addon, item_id: "" });
      form?.setFieldValue("addons", addons);
      form?.setFieldValue("selected_addon", "");
    }
  };

  const removeAddon = (item, form) => {
    const newAddon = form?.values?.addons.filter((items) => {
      return items !== item;
    });
    form?.setFieldValue("addons", newAddon);
  };

  const getAddon = (id) => {
    return ItemOption.find((item) => item._id === id) || {};
  };

  /** A cap on its way into the form: blank clears it, anything else is kept. */
  const setAddonLimit = (form, optionId, raw) => {
    const limits = { ...(form?.values?.addon_limits || {}) };
    if (raw === "") {
      delete limits[optionId];
    } else {
      limits[optionId] = { max_choice: Number(raw) };
    }
    form?.setFieldValue("addon_limits", limits);
  };

  /**
   * Why a cap cannot be saved, or null. Mirrors the backend guard
   * (`capSlots.cappedGroupsBrokenBy`): a group given more slots than its
   * ceiling allows can never be satisfied, so the item could not be ordered.
   */
  const addonLimitError = (form, optionId, slots) => {
    const cap = form?.values?.addon_limits?.[optionId]?.max_choice;
    if (cap == null || cap === "") {
      return null;
    }
    if (!Number.isInteger(cap) || cap < 1) {
      return t("validation_max_choice_invalid");
    }
    return cap < slots ? t("validation_max_choice_below_slots", { slots }) : null;
  };

  /**
   * Whether any ceiling on the form is unsavable — what blocks Submit. The caps
   * are not in the Yup schema, so without this a bad one submits and comes back
   * refused by the backend.
   */
  const isSubmitBlocked = (form) =>
    hasAddonLimitError(form) || Object.keys(form?.errors || {}).length > 0;

  const hasAddonLimitError = (form) =>
    addonGroupSlots(form?.values?.addons).some(
      (group) => addonLimitError(form, group.option_id, group.slots) !== null
    );

  /**
   * One row per GROUP, not per slot: a group listed twice is two slots but one
   * budget. Blank is no ceiling. Rendered for both the add and the edit form.
   */
  const renderAddonLimits = (form) => {
    const groups = addonGroupSlots(form?.values?.addons);
    if (!groups.length) {
      return null;
    }
    return (
      <div className="mb-3">
        <label className="form-label">
          {t("label_max_choice")}
          <Whisper placement="top" trigger="hover" speaker={<Tooltip>{t("help_max_choice")}</Tooltip>}>
            <div className="label-tooltip">
              <i className="ti ti-help-circle"></i>
            </div>
          </Whisper>
        </label>
        <div className="addon-limit-list">
          {groups.map((group) => {
            const error = addonLimitError(form, group.option_id, group.slots);
            const cap = form?.values?.addon_limits?.[group.option_id]?.max_choice ?? "";
            return (
              <div className="addon-limit-row" key={group.option_id}>
                <div className="addon-limit-group">
                  <span className="addon-limit-name">
                    {getTranslatedKey("addon_name", getAddon(group.option_id))}
                  </span>
                  <span className="addon-limit-slots">
                    {t("max_choice_slots", { slots: group.slots })}
                  </span>
                </div>
                <div className="addon-limit-field">
                  <div className="addon-limit-input">
                    <span className="addon-limit-input-label">{t("label_max_choice_cap")}</span>
                    <input
                      type="number"
                      className={"form-control no_spring_input" + (error ? " is-invalid" : "")}
                      placeholder={t("placeholder_max_choice")}
                      min="1"
                      step="1"
                      value={cap}
                      onChange={(e) => { setAddonLimit(form, group.option_id, e.target.value); }}
                    />
                  </div>
                  <span className="addon-limit-summary">
                    {cap === ""
                      ? t("max_choice_none")
                      : t("max_choice_summary", { max: cap })}
                  </span>
                </div>
                {error ? <span className="addon-limit-error">{error}</span> : null}
              </div>
            );
          })}
        </div>
      </div>
    );
  };

  useMemo(() => {
    document.addEventListener("language_change", function () {
      setLangChanged(!langChanged);
    });
  });

  const disabledOptions = (values) => {
    // if (values?.addons?.length) {
    //   return values?.addons.map((op) => op.option_id);
    // }
    // return [];
    const disabledIds = [];
    ItemOption.forEach((addon) => {
      let addonSelectedOptions = values?.addons.filter((op) => op.option_id === addon._id);
      if (addonSelectedOptions?.length === addon?.assigned_items?.length) {
        disabledIds.push(addon?._id);
      }
    });
    return disabledIds;
  };

  const isOptionSelected = (item, option, addons = []) => {
    if (addons.length) {
      let result = addons.filter(record => record?.option_id === item?.option_id && record?.item_id === option?._id);
      return result.length > 0;
    }
    return false
  };


  useEffect(() => {
    const handleSocketData = (response) => {
      if (response.event === SOCKET_EVENTS.RESTAURANT_DETAILS_CHANGED) {
        setRefreshList((current) => !current);
        if (selectedMenuItem) {
          getItemDetail(selectedMenuItem, openWithHeaderEdit);
        }
      }
    };

    SOCKET_CLIENT.on(SOCKET_CLIENT_EVENTS.GET_DATA, handleSocketData);

    return () => {
      SOCKET_CLIENT.off(SOCKET_CLIENT_EVENTS.GET_DATA, handleSocketData);
    };
  }, [selectedMenuItem, openWithHeaderEdit]);


  return (
    <main id="main-content">
      {/* main container  */}
      <div className="inner-container">
        <div className="page-header d-flex align-items-center">
          <h4 className="heading-title-text">
            {t("menu_item_label")} ({totalRecords})
          </h4>
        </div>
        <div className="card-outer-header menu-toolbar mb-4">
          <div className="search-box">
            <input
              type="text"
              className="form-control search-input"
              placeholder={t("input_placeholder_search")}
              onInput={(e) => {
                searchDebounce(e.target.value);
              }}
            />
          </div>
          <select
            className="form-control cp"
            value={filterCategoryId}
            onChange={(e) => {
              const catId = e.target.value;
              setPage(1);
              setFilterCategoryId(catId);
              setFilterSubCategoryId("");
              setFilterSubCategoryList([]);
              if (catId) fetchSubCategories(catId, setFilterSubCategoryList);
            }}
          >
            <option value="">{t("input_select_text")}</option>
            {categoryFilterOptions.map((item, index) => (
              <option key={index} value={item?._id}>
                {getTranslatedKey('name', item)}
              </option>
            ))}
          </select>
          <select
            className="form-control cp"
            value={filterSubCategoryId}
            disabled={!filterCategoryId}
            onChange={(e) => {
              setPage(1);
              setFilterSubCategoryId(e.target.value);
            }}
          >
            <option value="">{t("input_select_text")}</option>
            {filterSubCategoryList.map((item, index) => (
              <option key={index} value={item?._id}>
                {getTranslatedKey('name', item)}
              </option>
            ))}
          </select>
          <button className="btn btn-primary menu-toolbar-action" data-bs-toggle="modal" data-bs-target="#sort-modal" onClick={getSortableMenuItemList}>
            {t("sort_menu_item_label")}
          </button>
          <button
            onClick={() => {
              setOpenWithHeader(true);
              get_menu_item_code();
            }}
            className="btn btn-primary menu-toolbar-action"
          >
            <i className="ti ti-plus"></i> {t("add_item_label")}
          </button>
        </div>
        {loader ? (
          <GridLoader />
        ) : (
          <div className="dashboard-content-wraper">
            {List.length > 0 ? (
              <div className="category-list-wrap">
                <div className="category-list-grid menu-list-grid">
                  {List.map((item, index) => (
                    <div className="category-box category-menu-box" key={index}>
                      <CategoryCardActions
                        viewTarget="#view-new-item"
                        onView={() => { setSelectedMenuItem(item); getItemDetail(item); }}
                        onEdit={() => { setSelectedMenuItem(item); getItemDetail(item, true); }}
                        onClone={() => cloneItem(item)}
                        onDelete={() => deleteItem(item)}
                        className="category-name menu-img"
                      >
                        <img src={item.image} alt="" />
                      </CategoryCardActions>
                      <div className="menu-item-info">
                        {/* Not trimmed to 20 characters any more: the card is
                            250px wide and the name wraps, clamped to three
                            lines in CSS, so the whole name is readable without
                            a longer one deforming the grid row. */}
                        <h4>{getTranslatedKey('item_name', item)}</h4>
                        <span>¥ {showPrice(item?.total_price)}</span>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="table-status-info d-flex justify-content-between align-items-center mt-4">
                  <span>
                    {t("label_showing_entries", { shown: offset + List.length, total: totalRecords })}
                  </span>
                  <nav aria-label="Page navigation example" title={page}>
                    {totalRecords && totalRecords > itemPerPage ? (
                      <CustomPagination
                        datalength={totalRecords}
                        itemperpage={itemPerPage}
                        currentPage={page}
                        setPage={setPage}
                        modalPagination
                      />
                    ) : (
                      ""
                    )}
                  </nav>
                </div>
              </div>
            ) : (
              <RecordNotFound heading="no_assigned_item_text" />
            )}
          </div>
        )}
      </div>

      {/* sorting modal */}

      <div className="modal fade sort-modal" data-bs-backdrop="static" id="sort-modal" tabIndex="-1" aria-labelledby="sort-modalLabel" aria-hidden="true">
        <div className="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalToggleLabel">
                {t("menu_item_label")}{" "}
              </h1>

              <button type="button" className="btn-close btn-icon" onClick={handleCloseSorting} data-bs-dismiss="modal" aria-label="Close">
                <i className="ti ti-x"></i>
              </button>
            </div>

            <div className="modal-body">
              {sortableCategories && sortableCategories.length ? (
                <ReactSortable
                  list={sortableCategories}
                  setList={(newList) => setSortableCategories(newList)}
                  ghostClass="dropArea"
                  handle=".dragHandle"
                  forceFallback={true}
                  fallbackOnBody={false}
                  scroll={true}
                  bubbleScroll={true}
                  scrollSensitivity={60}
                  filter=".ignoreDrag"
                  preventOnFilter={true}
                  className="grid-drag-container"
                >
                  <>
                    {sortableCategories.map((record, i) => (
                      <div className="category-box category-menu-box dragHandle" key={i} style={{ background: record?.color }}>
                        <div className="category-name menu-img">
                          <img src={record.image} alt="" />
                        </div>
                        <div className="menu-item-info">
                          <h4>{getTranslatedKey('item_name', record)}</h4>
                          {/* {record.item_name} */}
                          <span>¥ {showPrice(record?.total_price)}</span>
                          {/* <span>¥ {record.total_price?.toFixed(0)}</span> */}
                        </div>
                      </div>
                    ))}
                  </>
                </ReactSortable>
              ) : (
                <RecordNotFound heading="no_assigned_item_text" text="" />
              )}
            </div>
            <div className="modal-footer justify-content-center">
              <button type="button" className="btn btn-danger me-2 d-none" data-bs-dismiss="modal" ref={sortingCloseBtn} aria-label="Close">
                Close
              </button>

              <button type="button" className="btn btn-primary" disabled={!isSortingChanged()} onClick={handleSortCategories}>
                {t("btn_save_changes")}
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* add item modal  */}
      <Drawer open={openWithHeader}>
        <Drawer.Header closeButton={false}>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <h5 className="mb-0">{t("add_item_label")}</h5>
            <button
              className="btn-icon"
              onClick={() => {
                setOpenWithHeader(false);
                addItemForm.resetForm();
              }}
            >
              <i className="ri-close-fill"></i>
            </button>
          </div>
        </Drawer.Header>
        <Drawer.Body
          onScroll={(e) => {
            handleOffcanvasScroll(e, "editNewEmail", "rsuite");
          }}
        >
          <form onSubmit={addItemForm.handleSubmit}>
            <div className="mb-3">
              <label className="form-label">
                {t("choose_category_label")}
                <span>*</span>{" "}
              </label>
              <select

                className="form-control cp"
                name="category_id"
                value={addItemForm?.values?.category_id}
                onChange={(e) => {
                  addItemForm.handleChange(e);
                  addItemForm.setFieldValue("consumption_tax_rate", findTax(addItemForm, e.target.value)?.tax_rate);
                  addItemForm.setFieldValue("sub_category_id", "");
                  fetchSubCategories(e.target.value, setAddSubCategoryList);
                }}
                onBlur={addItemForm.handleBlur}
              >
                <option value={""}>{t("input_select_text")}</option>
                {categoryList.map((item, index) => {
                  return (
                    <option key={index} value={item?._id}>
                      {item?.name}
                    </option>
                  );
                })}
              </select>
              <CustomError name="category_id" form={addItemForm} className="text-danger" />
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("label_sub_categories")}
              </label>
              <select
                className="form-control cp"
                name="sub_category_id"
                value={addItemForm?.values?.sub_category_id}
                onChange={addItemForm.handleChange}
                onBlur={addItemForm.handleBlur}
                disabled={!addItemForm?.values?.category_id}
              >
                <option value="">{t("input_placeholder_select")}</option>
                {addSubCategoryList.map((item, index) => (
                  <option key={index} value={item?._id}>{item?.name}</option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("menu_item_code_label")}
                <span>*</span>
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("menu_item_code_tooltip")}</Tooltip>}>
                  <div className="label-tooltip">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("enter_code_placeholder")}
                name="item_code"
                value={addItemForm?.values?.item_code}
                onChange={addItemForm.handleChange}
                onBlur={addItemForm.handleBlur}
                disabled
              />
              <CustomError name="item_code" form={addItemForm} className="text-danger" />
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("label_item_name_english")}<span>*</span>
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("item_name_en_tooltip")}</Tooltip>}>
                  <div className="label-tooltip">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("placeholder_item_name_english")}
                name="item_name"
                value={addItemForm?.values?.item_name}
                onChange={addItemForm.handleChange}
                onBlur={addItemForm.handleBlur}
              />
              <CustomError name="item_name" form={addItemForm} className="text-danger" />
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("label_item_name_japanese")}<span>*</span>
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("item_name_ja_tooltip")}</Tooltip>}>
                  <div className="label-tooltip">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("placeholder_item_name_japanese")}
                name="item_name_ja"
                value={addItemForm?.values?.item_name_ja}
                onChange={addItemForm.handleChange}
                onBlur={addItemForm.handleBlur}
              />
              <CustomError name="item_name_ja" form={addItemForm} className="text-danger" />
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("add_photo_label")}
                <span>*</span>
              </label>
              <input
                className="form-control imgInput"
                id="image"
                name="image"
                accept="image/*"
                type="file"
                // value={addItemForm?.values?.image}
                onChange={(event) => {
                  addItemForm.setFieldValue("image", event.target.files[0] || "");
                }}
              />

              <CustomError name="image" form={addItemForm} className="text-danger" />
              <span className="mt-2 d-block">{t("file_supported_label")}</span>
              {addItemForm.values.image && (
                <ul className="question-image-preview questions-ul">
                  <li className="pr_img_box">
                    <img src={URL.createObjectURL(addItemForm.values.image)} style={{ height: "100px" }} alt={"Profile_Img"} />
                    <button
                      type="button"
                      className="btn-icon"
                      style={{ position: "absolute", right: "5px", top: "5px", height: "30px", width: "30px", minWidth: "30px" }}
                      onClick={() => {
                        addItemForm.setFieldValue("image", null);
                        document.getElementById("image").value = "";
                      }}
                    >
                      <i className="ti ti-x"></i>
                    </button>
                  </li>
                </ul>
              )}
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("label_item_variation")}
                <span>*</span>
              </label>
              <div className="d-flex gap-5">
                <div className="form-check">
                  <input
                    className="form-check-input cp"
                    name="item_variation"
                    type="radio"
                    id={ITEM_VARIATION.FOOD}
                    value={ITEM_VARIATION.FOOD}
                    onChange={addItemForm.handleChange}
                    checked={addItemForm?.values?.item_variation === ITEM_VARIATION.FOOD}
                  />
                  <label className="form-check-label cp" htmlFor={ITEM_VARIATION.FOOD}>
                    {t("label_food")}
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input cp"
                    name="item_variation"
                    type="radio"
                    id={ITEM_VARIATION.DRINK}
                    value={ITEM_VARIATION.DRINK}
                    onChange={addItemForm.handleChange}
                    checked={addItemForm?.values?.item_variation === ITEM_VARIATION.DRINK}
                  />
                  <label className="form-check-label cp" htmlFor={ITEM_VARIATION.DRINK}>
                    {t("label_drink")}
                  </label>
                </div>
              </div>
              <CustomError name="item_variation" form={addItemForm} className="text-danger" />
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("type_item_label")}
                <span>*</span>
              </label>
              <div className="d-flex gap-5">
                <div className="form-check">
                  <input
                    className="form-check-input cp"
                    name="type"
                    type="radio"
                    id={ITEM_TYPES.ITEM}
                    value={ITEM_TYPES.ITEM}
                    onChange={addItemForm.handleChange}
                    checked={addItemForm?.values?.type === ITEM_TYPES.ITEM}
                  />
                  <label className="form-check-label cp" htmlFor={ITEM_TYPES.ITEM}>
                    {t("label_item")}
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input cp"
                    name="type"
                    type="radio"
                    id={ITEM_TYPES.SET_OF_ITEMS}
                    value={ITEM_TYPES.SET_OF_ITEMS}
                    onChange={addItemForm.handleChange}
                    checked={addItemForm?.values?.type === ITEM_TYPES.SET_OF_ITEMS}
                  />
                  <label className="form-check-label cp" htmlFor={ITEM_TYPES.SET_OF_ITEMS}>
                    {t("set_items_label")}
                  </label>
                </div>
              </div>
              <CustomError name="type" form={addItemForm} className="text-danger" />
            </div>

            {/* {
              addItemForm?.values?.type !== ITEM_TYPES.SET_OF_ITEMS && (
                <div className="mb-3">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={addItemForm?.values?.spice_level_needed}
                      onChange={(e) => {
                        addItemForm?.setFieldValue("spice_level_needed", e.target.checked);
                      }}
                      id="spice_level_needed"
                    />
                    <label className="form-check-label" htmlFor="spice_level_needed">
                      {t("spice_level_label")}
                    </label>
                  </div>
                </div>
              )
            }

            <div className="mb-3">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={addItemForm?.values?.is_upsell}
                  onChange={(e) => {
                    addItemForm?.setFieldValue("is_upsell", e.target.checked);
                  }}
                  id="is_upsell"
                />
                <label className="form-check-label" htmlFor="is_upsell">
                  {t("is_upsell_label")}
                </label>
              </div>
            </div> */}


            {addItemForm?.values?.type !== ITEM_TYPES.SET_OF_ITEMS && (
              <div className="d-flex align-items-center gap-4 mb-3">

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={addItemForm?.values?.spice_level_needed}
                    onChange={(e) => {
                      addItemForm?.setFieldValue("spice_level_needed", e.target.checked);
                    }}
                    id="spice_level_needed"
                  />
                  <label className="form-check-label" htmlFor="spice_level_needed">
                    {t("spice_level_label")}
                  </label>
                </div>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={addItemForm?.values?.is_upsell}
                    onChange={(e) => {
                      addItemForm?.setFieldValue("is_upsell", e.target.checked);
                    }}
                    id="is_upsell"
                  />
                  <label className="form-check-label" htmlFor="is_upsell">
                    {t("is_upsell_label")}
                  </label>
                </div>

              </div>
            )}

            {addItemForm?.values?.type === ITEM_TYPES.SET_OF_ITEMS && (
              <div className="mb-3">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={addItemForm?.values?.is_upsell}
                    onChange={(e) => {
                      addItemForm?.setFieldValue("is_upsell", e.target.checked);
                    }}
                    id="is_upsell"
                  />
                  <label className="form-check-label" htmlFor="is_upsell">
                    {t("is_upsell_label")}
                  </label>
                </div>
              </div>
            )}

            <div className="mb-3">
              <button
                type="button"
                className="btn btn-black w-100"
                onClick={() => {
                  setSelectedUpsellIds(sanitizeUpsellSelection(addItemForm?.values?.upsell_items || []));
                  setOpenUpsellModal(true);
                }}
              >
                {addFormValidUpsellCount > 0
                  ? `${addFormValidUpsellCount} ${t("items_selected_label")}`
                  : t("select_upsell_item_label")
                }
              </button>
            </div>


            {/* Dynamic addons >>>> */}
            {addItemForm?.values?.type === ITEM_TYPES.SET_OF_ITEMS ? (
              <>
                <div className="mb-3">
                  <label className="form-label">
                    {t("label_options")}
                    <span>*</span>{" "}
                    <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("options_tooltip")}</Tooltip>}>
                      <div
                        className="label-tooltip"
                      >
                        <i className="ti ti-help-circle"></i>
                      </div>
                    </Whisper>
                  </label>
                  <div className="d-flex gap-3">
                    <SelectPicker
                      classPrefix="restaurant"
                      data={OptionsData}
                      height="40px"
                      style={{ width: 300 }}
                      name="selected_addon"
                      value={addItemForm?.values?.selected_addon}
                      placeholder={t("input_select_text")}
                      onChange={(e) => {
                        addItemForm.setFieldValue("selected_addon", e);
                      }}
                      cleanable={false}
                      disabledItemValues={disabledOptions(addItemForm?.values)}
                    />
                    <button
                      type="button"
                      className="btn btn-black"
                      onClick={() => {
                        addAddon(addItemForm);
                      }}
                    >
                      {t("link_add")}
                    </button>
                  </div>
                  {typeof addItemForm?.errors?.addons === "string" && addItemForm?.errors?.addons ? <span className="d-block text-danger">{t(addItemForm?.errors?.addons)}</span> : null}
                </div>
                <AddonGroupRows
                  form={addItemForm}
                  getAddon={getAddon}
                  isOptionSelected={isOptionSelected}
                  removeAddon={removeAddon}
                />
                {renderAddonLimits(addItemForm)}
              </>
            ) : null}

            <div className="mb-3">
              <label className="form-label">
                {t("label_price")}
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("price_tooltip")}</Tooltip>}>
                  <div className="label-tooltip">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <div className="row">
                <div className="col">
                  <div className="input-group">
                    <span className="input-group-text" id="basic-addon1">
                      ¥
                    </span>
                    <input
                      type="number"
                      className="form-control no_spring_input"
                      placeholder={t("placeholder_price")}
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      name="price"
                      value={addItemForm?.values?.price}
                      onChange={addItemForm.handleChange}
                      onWheel={(event) => event.currentTarget.blur()}
                      onBlur={addItemForm.handleBlur}
                    />
                  </div>
                </div>
                {SHOW_TAX_TYPE_OPTION && (
                  <div className="col">
                    <select className="form-control cp" value={addItemForm?.values?.item_tax_type} onChange={addItemForm.handleChange} name="item_tax_type">
                      {Object.keys(ITEM_TAX_OPTIONS).map((key, i) => (
                        <option key={i} value={ITEM_TAX_OPTIONS[key]}>
                          {t(`item_tax_option_${key.toLocaleLowerCase()}`)}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                <CustomError name="price" form={addItemForm} className="text-danger" />
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("label_cost_price")}
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("cost_price_tooltip")}</Tooltip>}>
                  <div className="label-tooltip">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <div className="input-group">
                <span className="input-group-text" id="basic-addon1">
                  ¥
                </span>
                <input
                  type="number"
                  className="form-control no_spring_input"
                  placeholder={t("placeholder_cost_price")}
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  name="cost_price"
                  value={addItemForm?.values?.cost_price}
                  onChange={addItemForm.handleChange}
                  onWheel={(event) => event.currentTarget.blur()}
                  onBlur={addItemForm.handleBlur}
                />
              </div>
              <CustomError name="cost_price" form={addItemForm} className="text-danger" />
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("consumption_tax_rate")}
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("consumption_tax_rate_tooltip")}</Tooltip>}>
                  <div className="label-tooltip">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("placeholder_cost_price")}
                value={`${addItemForm?.values?.consumption_tax_rate}% tax`}
                disabled
                aria-label="Username"
                aria-describedby="basic-addon1"
              />
              {/* <CustomError name="consumption_tax_rate" form={addItemForm} className="text-danger" /> */}
            </div>
            <div className="mb-3">
              <div className="d-flex align-items-center justify-content-between">
                <span>{t("calculated_tax_label")}</span>
                <span>¥ {showPrice(findTax()?.tax_price)}</span>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <span>{t("price_with_tax")}</span>
                <span>¥ {showPrice(findTax()?.price_with_tax)}</span>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <span>{t("price_without_tax")}</span>
                <span>¥ {showPrice(findTax()?.price_without_tax)}</span>
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("label_short_description")}
                <span>*</span>
              </label>
              <textarea
                className="form-control"
                style={{ height: "120px" }}
                name="short_description"
                value={addItemForm?.values?.short_description}
                onChange={addItemForm.handleChange}
                onBlur={addItemForm.handleBlur}
              ></textarea>
              <CustomError name="short_description" form={addItemForm} className="text-danger" />
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("label_short_description_ja")}
                <span>*</span>
              </label>
              <textarea
                className="form-control"
                style={{ height: "120px" }}
                name="short_description_ja"
                value={addItemForm?.values?.short_description_ja}
                onChange={addItemForm.handleChange}
                onBlur={addItemForm.handleBlur}
              ></textarea>
              <CustomError name="short_description_ja" form={addItemForm} className="text-danger" />
            </div>
            <div className="button-form">
              <button
                type="submit"
                className={"btn btn-primary w-100" + (addSubmissionLoader ? " btn-loader" : "")}
                disabled={isSubmitBlocked(addItemForm)}
              >
                {t("btn_submit")}
              </button>
            </div>
          </form>
        </Drawer.Body>
      </Drawer>

      {/* EDIT ITEM MODAL */}

      <Drawer open={openWithHeaderEdit}>
        <Drawer.Header closeButton={false}>
          <div className="d-flex justify-content-between w-100 align-items-center">
            <h5 className="mb-0">{t("edit_item_label")}</h5>
            <button
              className="btn-icon"
              onClick={() => {
                setSelectedMenuItem(null);
                setOpenWithHeaderEdit(false);
                editItemForm.resetForm();
              }}
            >
              <i className="ri-close-fill"></i>
            </button>
          </div>
        </Drawer.Header>
        <Drawer.Body
          onScroll={(e) => {
            handleOffcanvasScroll(e, "editEmail", "rsuite");
          }}
        >
          <form onSubmit={editItemForm.handleSubmit}>
            <div className="mb-3">
              <label className="form-label">
                {t("choose_category_label")}
                <span>*</span>{" "}
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("choose_category_tooltip")}</Tooltip>}>
                  <div className="label-tooltip">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <select
                className="form-control cp"
                name="category_id"
                value={editItemForm?.values?.category_id}
                onChange={(e) => {
                  editItemForm.handleChange(e);
                  editItemForm.setFieldValue("consumption_tax_rate", findTax(editItemForm, e.target.value)?.tax_rate);
                  editItemForm.setFieldValue("sub_category_id", "");
                  fetchSubCategories(e.target.value, setEditSubCategoryList);
                }}
                onBlur={editItemForm.handleBlur}
              >
                <option value={""}>{t("input_select_text")}</option>
                {categoryList.map((item, index) => {
                  return (
                    <option key={index} value={item?._id}>
                      {item?.name}
                    </option>
                  );
                })}
              </select>
              <CustomError name="category_id" form={editItemForm} className="text-danger" />
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("label_sub_categories")}
              </label>
              <select
                className="form-control cp"
                name="sub_category_id"
                value={editItemForm?.values?.sub_category_id}
                onChange={editItemForm.handleChange}
                onBlur={editItemForm.handleBlur}
                disabled={!editItemForm?.values?.category_id}
              >
                <option value="">{t("input_placeholder_select")}</option>
                {editSubCategoryList.map((item, index) => (
                  <option key={index} value={item?._id}>{item?.name}</option>
                ))}
              </select>
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("menu_item_code_label")}
                <span>*</span>
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("menu_item_code_tooltip")}</Tooltip>}>
                  <div className="label-tooltip">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("placeholder_code")}
                name="item_code"
                value={editItemForm?.values?.item_code}
                onChange={editItemForm.handleChange}
                onBlur={editItemForm.handleBlur}
                disabled
              />
              <CustomError name="item_code" form={editItemForm} className="text-danger" />
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("label_item_name_english")}<span>*</span>
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("item_name_en_tooltip")}</Tooltip>}>
                  <div className="label-tooltip">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("placeholder_item_name_english")}
                name="item_name"
                value={editItemForm?.values?.item_name}
                onChange={editItemForm.handleChange}
                onBlur={editItemForm.handleBlur}
              />
              <CustomError name="item_name" form={editItemForm} className="text-danger" />
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("label_item_name_japanese")}<span>*</span>
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("item_name_ja_tooltip")}</Tooltip>}>
                  <div className="label-tooltip">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("placeholder_item_name_japanese")}
                name="item_name_ja"
                value={editItemForm?.values?.item_name_ja}
                onChange={editItemForm.handleChange}
                onBlur={editItemForm.handleBlur}
              />
              <CustomError name="item_name_ja" form={editItemForm} className="text-danger" />
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("add_photo_label")}
                <span>*</span>
              </label>
              <input
                className="form-control imgInput"
                id="image"
                name="image"
                accept="image/*"
                type="file"
                // value={addItemForm?.values?.image}
                onChange={(event) => {
                  editItemForm.setFieldValue("image", event.target.files[0] || "");
                }}
              />

              <CustomError name="image" form={editItemForm} className="text-danger" />
              <span className="mt-2 d-block">{t("file_supported_label")}</span>
              {editItemForm.values.image && (
                <ul className="question-image-preview questions-ul">
                  <li className="pr_img_box">
                    <img src={editItemForm.values.image instanceof File ? URL.createObjectURL(editItemForm.values.image) : editItemForm.values.image} style={{ height: "100px" }} alt={"Profile_Img"} />
                    <button
                      type="button"
                      className="btn-icon"
                      style={{ position: "absolute", right: "5px", top: "5px", height: "30px", width: "30px", minWidth: "30px" }}
                      onClick={() => {
                        editItemForm.setFieldValue("image", null);
                        document.getElementById("image").value = "";
                      }}
                    >
                      <i className="ti ti-x"></i>
                    </button>
                  </li>
                </ul>
              )}
            </div>

            <div className="mb-3">
              <label className="form-label">
                {t("label_item_variation")}
                <span>*</span>
              </label>
              <div className="d-flex gap-5">
                <div className="form-check">
                  <input
                    className="form-check-input cp"
                    name="item_variation"
                    type="radio"
                    id={ITEM_VARIATION.FOOD}
                    value={ITEM_VARIATION.FOOD}
                    onChange={editItemForm.handleChange}
                    checked={editItemForm?.values?.item_variation === ITEM_VARIATION.FOOD}
                  />
                  <label className="form-check-label cp" htmlFor={ITEM_VARIATION.FOOD}>
                    {t("label_food")}
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input cp"
                    name="item_variation"
                    type="radio"
                    id={ITEM_VARIATION.DRINK}
                    value={ITEM_VARIATION.DRINK}
                    onChange={editItemForm.handleChange}
                    checked={editItemForm?.values?.item_variation === ITEM_VARIATION.DRINK}
                  />
                  <label className="form-check-label cp" htmlFor={ITEM_VARIATION.DRINK}>
                    {t("label_drink")}
                  </label>
                </div>
              </div>
              <CustomError name="item_variation" form={editItemForm} className="text-danger" />
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("type_item_label")}
                <span>*</span>
              </label>
              <div className="d-flex gap-5">
                <div className="form-check">
                  <input
                    className="form-check-input cp"
                    name="type"
                    type="radio"
                    id={ITEM_TYPES.ITEM}
                    value={ITEM_TYPES.ITEM}
                    onChange={editItemForm.handleChange}
                    checked={editItemForm?.values?.type === ITEM_TYPES.ITEM}
                  />
                  <label className="form-check-label cp" htmlFor={ITEM_TYPES.ITEM}>
                    {t("label_item")}
                  </label>
                </div>
                <div className="form-check">
                  <input
                    className="form-check-input cp"
                    name="type"
                    type="radio"
                    id={ITEM_TYPES.SET_OF_ITEMS}
                    value={ITEM_TYPES.SET_OF_ITEMS}
                    onChange={editItemForm.handleChange}
                    checked={editItemForm?.values?.type === ITEM_TYPES.SET_OF_ITEMS}
                  />
                  <label className="form-check-label cp" htmlFor={ITEM_TYPES.SET_OF_ITEMS}>
                    {t("set_items_label")}
                  </label>
                </div>
              </div>
              <CustomError name="type" form={editItemForm} className="text-danger" />
            </div>
            {/* {
              editItemForm?.values?.type !== ITEM_TYPES.SET_OF_ITEMS && (
                <div className="mb-3">
                  <div className="form-check">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      checked={editItemForm?.values?.spice_level_needed}
                      onChange={(e) => {
                        editItemForm?.setFieldValue("spice_level_needed", e.target.checked);
                      }}
                      id="spice_level_needed"
                    />
                    <label className="form-check-label" htmlFor="spice_level_needed">
                      {t("spice_level_label")}
                    </label>
                  </div>
                </div>
              )
            }
            <div className="mb-3">
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  checked={editItemForm?.values?.is_upsell}
                  onChange={(e) => {
                    editItemForm?.setFieldValue("is_upsell", e.target.checked);
                  }}
                  id="is_upsell"
                />
                <label className="form-check-label" htmlFor="is_upsell">
                  {t("is_upsell_label")}
                </label>
              </div>
            </div> */}
            {editItemForm?.values?.type !== ITEM_TYPES.SET_OF_ITEMS && (
              <div className="d-flex align-items-center gap-4 mb-3">

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={editItemForm?.values?.spice_level_needed}
                    onChange={(e) => {
                      editItemForm?.setFieldValue("spice_level_needed", e.target.checked);
                    }}
                    id="spice_level_needed"
                  />
                  <label className="form-check-label" htmlFor="spice_level_needed">
                    {t("spice_level_label")}
                  </label>
                </div>

                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={editItemForm?.values?.is_upsell}
                    onChange={(e) => {
                      editItemForm?.setFieldValue("is_upsell", e.target.checked);
                    }}
                    id="is_upsell"
                  />
                  <label className="form-check-label" htmlFor="is_upsell">
                    {t("is_upsell_label")}
                  </label>
                </div>

              </div>
            )}

            {editItemForm?.values?.type === ITEM_TYPES.SET_OF_ITEMS && (
              <div className="mb-3">
                <div className="form-check">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    checked={editItemForm?.values?.is_upsell}
                    onChange={(e) => {
                      editItemForm?.setFieldValue("is_upsell", e.target.checked);
                    }}
                    id="is_upsell"
                  />
                  <label className="form-check-label" htmlFor="is_upsell">
                    {t("is_upsell_label")}
                  </label>
                </div>
              </div>
            )}
            <div className="mb-3">
              <button
                type="button"
                className="btn btn-black w-100"
                onClick={() => {
                  setSelectedUpsellIds(sanitizeUpsellSelection(editItemForm?.values?.upsell_items || [], currentEditItemId));
                  setOpenUpsellModal(true);
                }}
              >
                {editFormValidUpsellCount > 0
                  ? `${editFormValidUpsellCount} ${t("items_selected_label")}`
                  : t("select_upsell_item_label")
                }
              </button>
            </div>
            {/* Dynamic addons >>>> */}
            {editItemForm?.values?.type === ITEM_TYPES.SET_OF_ITEMS ? (
              <>
                <div className="mb-3">
                  <label className="form-label">
                    {t("label_options")}
                    <span>*</span>{" "}
                    <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("options_tooltip")}</Tooltip>}>
                      <div
                        className="label-tooltip"
                      >
                        <i className="ti ti-help-circle"></i>
                      </div>
                    </Whisper>
                  </label>
                  <div className="d-flex gap-3">
                    <SelectPicker
                      classPrefix="restaurant"
                      data={OptionsData}
                      style={{ width: 300 }}
                      name="selected_addon"
                      placeholder={t("input_select_text")}
                      value={editItemForm?.values?.selected_addon}
                      onChange={(e) => {
                        editItemForm.setFieldValue("selected_addon", e);
                      }}
                      cleanable={false}
                      disabledItemValues={disabledOptions(editItemForm?.values)}
                    />
                    <button
                      type="button"
                      className="btn btn-black"
                      onClick={() => {
                        addAddon(editItemForm);
                      }}
                    >
                      {t("link_add")}
                    </button>
                  </div>
                  {typeof editItemForm?.errors?.addons === "string" && editItemForm?.errors?.addons ? <span className="d-block text-danger">{t(editItemForm?.errors?.addons)}</span> : null}
                </div>
                <AddonGroupRows
                  form={editItemForm}
                  getAddon={getAddon}
                  isOptionSelected={isOptionSelected}
                  removeAddon={removeAddon}
                />
                {renderAddonLimits(editItemForm)}
              </>
            ) : null}
            {/* Dynamic addons <<<< */}
            <div className="mb-3">
              <label className="form-label">
                {t("label_price")}
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("price_tooltip")}</Tooltip>}>
                  <div className="label-tooltip">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <div className="row">
                <div className="col">
                  <div className="input-group">
                    <span className="input-group-text" id="basic-addon1">
                      ¥
                    </span>
                    <input
                      type="number"
                      className="form-control no_spring_input"
                      placeholder={t("placeholder_price")}
                      aria-label="Username"
                      aria-describedby="basic-addon1"
                      name="price"
                      value={editItemForm?.values?.price}
                      onChange={editItemForm.handleChange}
                      onWheel={(event) => event.currentTarget.blur()}
                      onBlur={editItemForm.handleBlur}
                    />
                  </div>
                </div>
                {SHOW_TAX_TYPE_OPTION && (
                  <div className="col">
                    <select className="form-control cp" value={editItemForm?.values?.item_tax_type} onChange={editItemForm.handleChange} name="item_tax_type">
                      {Object.keys(ITEM_TAX_OPTIONS).map((key, i) => (
                        <option key={i} value={ITEM_TAX_OPTIONS[key]}>
                          {t(`item_tax_option_${key.toLocaleLowerCase()}`)}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                <CustomError name="price" form={editItemForm} className="text-danger" />
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("label_cost_price")}
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("cost_price_tooltip")}</Tooltip>}>
                  <div className="label-tooltip">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <div className="input-group">
                <span className="input-group-text" id="basic-addon1">
                  ¥
                </span>
                <input
                  type="number"
                  className="form-control no_spring_input"
                  placeholder={t("placeholder_cost_price")}
                  aria-label="Username"
                  aria-describedby="basic-addon1"
                  name="cost_price"
                  value={editItemForm?.values?.cost_price}
                  onChange={editItemForm.handleChange}
                  onWheel={(event) => event.currentTarget.blur()}
                  onBlur={editItemForm.handleBlur}
                />
              </div>
              <CustomError name="cost_price" form={editItemForm} className="text-danger" />
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("consumption_tax_rate")}
                <Whisper placement="top" trigger="hover" speaker={<Tooltip> {t("consumption_tax_rate_tooltip")}</Tooltip>}>
                  <div className="label-tooltip">
                    <i className="ti ti-help-circle"></i>
                  </div>
                </Whisper>
              </label>
              <input
                type="text"
                className="form-control"
                placeholder={t("placeholder_cost_price")}
                value={`${editItemForm.values.consumption_tax_rate}% tax`}
                disabled
                aria-label="Username"
                aria-describedby="basic-addon1"
              />
              {/* <CustomError name="consumption_tax_rate" form={addItemForm} className="text-danger" /> */}
            </div>
            <div className="mb-3">
              <div className="d-flex align-items-center justify-content-between">
                <span>{t("calculated_tax_label")}</span>
                <span>¥ {showPrice(findTax(editItemForm, editItemForm?.values?.category_id)?.tax_price)}</span>
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <span>{t("price_with_tax")}</span>
                {editItemForm?.values?.category_id && editItemForm?.values?.price ? <span>¥ {showPrice(findTax(editItemForm, editItemForm?.values?.category_id)?.price_with_tax)}</span> : null}
              </div>
              <div className="d-flex align-items-center justify-content-between">
                <span>{t("price_without_tax")}</span>
                <span>¥ {showPrice(findTax(editItemForm, editItemForm?.values?.category_id)?.price_without_tax)}</span>
              </div>
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("label_short_description")}
                <span>*</span>
              </label>
              <textarea
                className="form-control"
                style={{ height: "120px" }}
                name="short_description"
                value={editItemForm?.values?.short_description}
                onChange={editItemForm.handleChange}
                onBlur={editItemForm.handleBlur}
              ></textarea>
              <CustomError name="short_description" form={editItemForm} className="text-danger" />
            </div>
            <div className="mb-3">
              <label className="form-label">
                {t("label_short_description_ja")}
                <span>*</span>
              </label>
              <textarea
                className="form-control"
                style={{ height: "120px" }}
                name="short_description_ja"
                value={editItemForm?.values?.short_description_ja}
                onChange={editItemForm.handleChange}
                onBlur={editItemForm.handleBlur}
              ></textarea>
              <CustomError name="short_description_ja" form={editItemForm} className="text-danger" />
            </div>
            <div className="button-form">
              {/* Same guard as the add form — see the comment there. */}
              <button
                type="submit"
                className={"btn btn-primary w-100" + (editSubmissionLoader ? " btn-loader" : "")}
                disabled={isSubmitBlocked(editItemForm) || !editItemForm.dirty}
              >
                {t("btn_update")}
              </button>
            </div>
          </form>
        </Drawer.Body>
      </Drawer>

      {/* view modal for menu item  */}
      <div className="offcanvas offcanvas-end right-modal-w" id="view-new-item" data-bs-backdrop="static" tabIndex="-1" aria-labelledby="staticBackdropLabel">
        <div className="offcanvas-header">
          <h5 className="offcanvas-title" id="offcanvasRightLabel">
            {t("item_detail_label")}
          </h5>
          <button type="button" className="btn btn-icon ms-auto" data-bs-dismiss="offcanvas" aria-label="Close" onClick={() => { setSelectedMenuItem(null); }}>
            <i className="ti ti-x"></i>
          </button>
        </div>
        <div
          className="offcanvas-body"
          onScroll={(e) => {
            handleOffcanvasScroll(e, "view-new-item");
          }}
        >
          <div className="view-info">
            <div className="row gap-4">
              <div className="col-md-12">
                <h4 >{t("label_category")} :</h4>
                <p >{categoryList.find((item) => item?._id === ItemDetail.category_id)?.name}</p>
              </div>
              {ItemDetail?.sub_category_id && (
                <div className="col-md-12">
                  <h4>{t("label_sub_categories")} :</h4>
                  <p>{editSubCategoryList.find((item) => item?._id === ItemDetail.sub_category_id)?.name}</p>
                </div>
              )}
              <div className="col-md-12">
                <h4 >{t("menu_item_code_label")} :</h4>
                <p >{ItemDetail?.item_code}</p>
              </div>
              <div className="col-md-12">
                  <h4 >{t("label_item_name_english")} :</h4>
                <p >{ItemDetail?.item_name}</p>
              </div>
              <div className="col-md-12">
                  <h4 >{t("label_item_name_japanese")} :</h4>
                <p >{ItemDetail?.item_name_ja}</p>
              </div>
              <div className="col-md-12">
                <h4 >{t("label_photo")} :</h4>
                {editItemForm.values.image && (
                  <ul className="question-image-preview questions-ul">
                    <li className="pr_img_box">
                      <img
                        src={editItemForm.values.image instanceof File ? URL.createObjectURL(editItemForm.values.image) : editItemForm.values.image}
                        style={{ height: "100px" }}
                        alt={"Profile_Img"}
                      />
                    </li>
                  </ul>
                )}
              </div>
              <div className="col-md-12">
                <h4 >{t("label_item_variation")} :</h4>

                <div className="input-group">
                  <p >{t("label_" + ItemDetail?.item_variation)} </p>
                </div>
              </div>
              <div className="col-md-12">
                <h4 >{t("type_item_label")} :</h4>

                <div className="input-group">
                  <p >{t(ItemDetail?.type)} </p>
                </div>
              </div>
              <div className="col-md-12">
                <h4 >{t("spice_level_label")} :</h4>

                <div className="input-group">
                  <p >{`${t(booleanMask(ItemDetail?.spice_level_needed))}`}</p>
                </div>
              </div>

              <div className="col-md-12">
                <h4 >{t("is_upsell_label")} :</h4>

                <div className="input-group">
                  <p >{`${t(booleanMask(ItemDetail?.is_upsell))}`}</p>
                </div>
              </div>

              {ItemDetail?.type === ITEM_TYPES.SET_OF_ITEMS && (
                <div className="col-md-12">
                  <h4 >{t("label_options")} :</h4>

                  {/* <div className="bordered-div"> */}
                  {ItemDetail && ItemDetail?.addons_data && ItemDetail?.addons_data?.length > 0 ? (
                    <>
                      {" "}
                      {ItemDetail?.addons_data.map((data, index) => (
                        <div key={index} className="border border-1 p-2 mb-2 rounded-2">
                          <h6 className="m-0">
                            {data.addon_name} - <span style={{ fontWeight: "400" }}>{data.item_name}</span>
                          </h6>
                        </div>
                      ))}
                    </>
                  ) : null}

                  {/* </div> */}
                </div>
              )}

              <div className="col-md-12">
                <label >{t("label_price")} :</label>
                <div className="row">
                  <div className="col">
                    <div className="input-group">
                      <p >¥ {ItemDetail?.total_price}</p>
                    </div>
                  </div>
                  <p >{ }</p>
                </div>
              </div>
              <div className="col-md-12">
                <h4 >{t("label_cost_price")} :</h4>
                <div className="input-group">
                  <p >¥ {ItemDetail?.cost_price}</p>
                </div>
              </div>
              <div className="col-md-12">
                <h4 >{t("item_tax_type")} :</h4>
                <div className="input-group">
                  <p >{t(`label_${ItemDetail?.item_tax_type}`)}</p>
                </div>
              </div>
              <div className="col-md-12">
                <h4 >{t("consumption_tax_rate")} :</h4>
                <p >{ItemDetail?.consumption_tax_rate} % {t('tax_label')}</p>
              </div>

              <div className="col-md-12">
                <h4 >{t("calculated_tax_label")} :</h4>
                <span>¥ {showPrice(ItemDetail?.tax_price)}</span>
              </div>
              <div className="col-md-12">
                <h4 >{t("price_with_tax")} :</h4>
                <p >¥ {showPrice(ItemDetail?.total_price)}</p>
              </div>
              <div className="col-md-12">
                <h4 >{t("price_without_tax")} :</h4>
                <p >¥ {showPrice(ItemDetail?.price)}</p>
              </div>
              <div className="col-md-12">
                <h4 >{t("label_short_description")} :</h4>
                <p >{ItemDetail?.short_description}</p>
              </div>
              <div className="col-md-12">
                <h4 >{t("label_short_description_ja")}:</h4>
                <p >{ItemDetail?.short_description_ja}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal open={openUpsellModal} onClose={() => setOpenUpsellModal(false)}>
        <Modal.Header>
          <Modal.Title>{t("select_upsell_item_label")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="d-flex flex-column gap-2">
            {upsellOptionsForModal.map((item) => (
              <div
                key={item._id}
                className={`d-flex align-items-center gap-3 p-2 rounded border cp ${selectedUpsellIds.includes(item._id) ? "border-dark bg-light" : ""
                  }`}
                onClick={() => {
                  setSelectedUpsellIds((prev) =>
                    prev.includes(item._id)
                      ? prev.filter((id) => id !== item._id)
                      : [...prev, item._id]
                  );
                }}
              >
                <input
                  type="checkbox"
                  className="form-check-input mt-0"
                  checked={selectedUpsellIds.includes(item._id)}
                  onChange={() => { }}
                />
                {item.image && (
                  <img
                    src={item.image}
                    alt={item.item_name}
                    style={{ width: "45px", height: "45px", objectFit: "cover", borderRadius: "6px" }}
                  />
                )}
                <div className="flex-grow-1">
                  <div className="fw-semibold">{item.item_name}</div>
                  <small className="text-muted">¥ {item.price}</small>
                </div>
              </div>
            ))}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <button
            type="button"
            className="btn btn-primary"
            // onClick={() => {
            //   addItemForm.setFieldValue("upsell_items", selectedUpsellIds); // ✅ form mein save
            //   setOpenUpsellModal(false);
            // }}

            onClick={() => {
              const sanitizedUpsellIds = sanitizeUpsellSelection(selectedUpsellIds, openWithHeaderEdit ? currentEditItemId : null);
              if (openWithHeaderEdit) {
                editItemForm.setFieldValue("upsell_items", sanitizedUpsellIds);
              } else {
                addItemForm.setFieldValue("upsell_items", sanitizedUpsellIds);
              }
              setOpenUpsellModal(false);
            }}
          >
            {t("btn_save")} ({selectedUpsellIds.length})
          </button>
          <button
            type="button"
            className="btn btn-secondary ms-2"
            onClick={() => setOpenUpsellModal(false)}
          >
            {t("btn_cancel")}
          </button>
        </Modal.Footer>
      </Modal>
    </main>
  );
}
